import React from 'react';

const TranslationContext = React.createContext();

export default TranslationContext;